// Step 27 Option B: shared approve button + undo toast.
// Driven by the useApprove hook. Surfaces share one instance of the hook
// (per page) and render both the button (per row) + the toast (once,
// fixed bottom-right). Parallel shape to RejectMomentDialog.

import { CheckCircle, Undo2 } from 'lucide-react'

export function ApproveButton({ onClick, marked = false, size = 'md', disabled = false }) {
  const padding = size === 'sm' ? '2px 8px' : '4px 10px'
  const fontSize = size === 'sm' ? 11 : 12
  const iconSize = size === 'sm' ? 10 : 11
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={marked
        ? 'Already approved — click to undo'
        : 'Approve — mark as a real reel-worthy moment (feeds the eval gold set + future RAG exemplars)'}
      style={{
        padding, fontSize,
        background: marked ? 'rgba(34,197,94,0.12)' : 'transparent',
        border: '1px solid ' + (marked ? '#16a34a' : '#14532d'),
        borderRadius: 4,
        color: marked ? '#86efac' : '#4ade80',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        display: 'inline-flex', alignItems: 'center', gap: 4,
      }}>
      <CheckCircle size={iconSize} />
      {marked ? 'Approved' : 'Approve'}
    </button>
  )
}

export function ApproveUndoToast({ hook, offsetBottom = 20 }) {
  if (!hook.undoToast) return null
  return (
    <div style={{
      position: 'fixed', bottom: offsetBottom, right: 20, zIndex: 9998,
      background: '#0f172a', border: '1px solid #16a34a',
      borderRadius: 6, padding: '10px 14px',
      display: 'flex', alignItems: 'center', gap: 12,
      boxShadow: '0 4px 12px rgba(0,0,0,0.5)', maxWidth: 480,
    }}>
      <CheckCircle size={14} style={{ color: '#86efac' }} />
      <div style={{ fontSize: 12, color: '#ddd', flex: 1 }}>
        {hook.undoToast.duplicate ? 'Already approved' : 'Approved'}:{' '}
        <span style={{ color: '#86efac' }}>{hook.undoToast.label}</span>
      </div>
      <button onClick={hook.undo}
        style={{
          padding: '4px 10px', background: 'transparent',
          border: '1px solid #555', borderRadius: 4, color: '#bfdbfe',
          cursor: 'pointer', fontSize: 12,
          display: 'inline-flex', alignItems: 'center', gap: 4,
        }}>
        <Undo2 size={11} /> Undo
      </button>
    </div>
  )
}
